import { CommentReportFiltersState, CommentReportFiltersActionTypes, READ_COMMENT_REPORT_FILTERS_REQUEST, READ_COMMENT_REPORT_FILTERS_SUCCESS, READ_COMMENT_REPORT_FILTERS_FAILURE } from "store/reducers/types/commentReport/commentReportFilters";

const defaultState: CommentReportFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function commentReportFilters(state = defaultState, action: CommentReportFiltersActionTypes): CommentReportFiltersState {
  switch (action.type) {
    case READ_COMMENT_REPORT_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_COMMENT_REPORT_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_COMMENT_REPORT_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};